// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import React, { FC, createRef, KeyboardEvent, useState, Fragment, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import type { FormInstance } from 'antd/es/form'
import { useHistory } from 'react-router-dom'
import {
    Space, Form, Input, Button, Typography, List,
    Skeleton, Modal, Select, notification, Pagination
} from 'antd'
import { CheckCircleOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import type { IAppState } from '@/store/reducers'
import { getTechClassification, getWorkgroup, setClassificationPagination } from '@/store/actions/tableEdit.action'
import type { IClassification } from '@/store/models/tableEdit.model'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { addTechClassification, delTechClassification, editTechClassification } from '@/services/table.service'
import NoSpaceInput from '@/components/noSpaceInput'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import Nav from '@/components/nav'
import { useForm } from 'antd/es/form/Form'

const ClassificationEdit: FC = () => {
    const history = useHistory()
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const [listLoading, setListLoading] = useState(true)
    const [classArr, setClassArr] = useState<any []>([])
    const [selectGroupworkId, setSelectGroupworkId] = useState<number | string>('')
    const route = useSelector((state: IAppState) => state.router)
    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const classification = useSelector((state: IAppState) => state.tableEditData.techClassification)
    const classficationPagination = useSelector((state: IAppState) => state.tableEditData.classficationPagination)
    // const formRef = createRef<FormInstance>()
    const [form] = useForm()
    const locationSearch = useRef<any>({})
    const { Text } = Typography
    const { Option } = Select
    const [modalVisible, setModalVisible] = useState(false)
    const [modalTitle, setModalTitle] = useState('')

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 10 },
    }
    const tailLayout = {
        wrapperCol: { offset: 6, span: 10 },
    }

    const popMsg = (msg: string) => {
        const args = {
            message: msg,
            description: '',
            icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
            duration: 3,
        }
        notification.open(args)
    }

    const onReset = () => {
        form.resetFields()
        form.setFieldValue('workGroupId', selectGroupworkId)
        // setSelectGroupworkId('')
    }

    const handleAdd = () => {
        setModalTitle(t('add'))
        setModalVisible(true)
        onReset()
    }

    const onEditClassification = (item: IClassification) => {
        form.setFieldsValue({
            id: item.classId,
            version: item.version,
            classificationName: item.classificationName,
            workGroupId: item.workGroup.id
        })
        setSelectGroupworkId(item.workGroup.id)
        setModalTitle(t('edit'))
        setModalVisible(true)
    }

    const handleCancel = () => {
        setModalVisible(false)
        onReset()
    }

    const onFinish = async (values: any) => {
        try {
            if (values.id) {
                await editTechClassification(values)
            } else {
                await addTechClassification(values)
            }
            popMsg(t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'))
            setModalVisible(false)
            onReset()
            let lastPage = 0
            if(values.id){
                lastPage = Math.ceil((classficationPagination.total as number) / (classficationPagination.pageSize as number))
            }else{
                lastPage = Math.ceil((classficationPagination.total as number + 1) / (classficationPagination.pageSize as number))
            }
            dispatch(setClassificationPagination({
                pageIndex: lastPage
            }))
            dispatch(getTechClassification({
                pageNo: lastPage,
                pageSize: classficationPagination.pageSize,
                workGroupId: locationSearch.current.workGroupId
            }))
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const onDelClassification = (item: IClassification) => {
        Modal.confirm({
            title: t('confirmDel'),
            centered: true,
            okText: t('confirm'),
            cancelText: t('cancel'),
            async onOk () {
                try {
                    await delTechClassification(item.classId)
                    popMsg(t('delete') + (i18n.language !== 'zh' ? ' ' : '') + t('success'))
                    const lastPage = Math.ceil((classficationPagination.total as number - 1) / (classficationPagination.pageSize as number))
                    dispatch(getTechClassification({
                        pageNo: lastPage,
                        pageSize: classficationPagination.pageSize,
                        workGroupId: locationSearch.current.workGroupId
                    }))
                } catch (error: any) {
                    const str = getErrorStr(error)
                    dispatch(requestFail(str))
                }
            }
        })
    }

    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/projectInfo',
            breadcrumbName: 'Project Info 列表',
        },
        {
            path: '/workgroupEdit',
            breadcrumbName: t('Class Manage'),
        },
    ])
    useEffect(() => {
        // 获取 workgroupList
        if (!workgroupList.length) {
            dispatch(getWorkgroup())
        }

        const routeParams = new URLSearchParams(location.search)
        const worGroupIdParam = routeParams.get('workGroupId')
        locationSearch.current = {
            workGroupId: +(worGroupIdParam || ''),
        }
        
        // 初始化时重置页码为1
        dispatch(setClassificationPagination({
            pageIndex: 1
        }))

        // 从编辑页返回时，参数从 store route 中获取
        if (worGroupIdParam) {
            const _routes = [...routes]
            const curWorkgroup = workgroupList.find(item => item.id === locationSearch.current.workGroupId)
            if (curWorkgroup) {
                _routes[_routes.length - 2].breadcrumbName = curWorkgroup.groupName
            }
            setRoutes(_routes)

            setSelectGroupworkId(locationSearch.current.workGroupId)
            console.log('locationSearch.current.workGroupId: ', locationSearch.current.workGroupId)
            form.setFieldsValue({
                workGroupId: locationSearch.current.workGroupId
            })
        }
    }, [])
    useEffect(() => {
        // 获取 classificationList
        dispatch(getTechClassification({
            pageNo: classficationPagination.pageIndex,
            pageSize: classficationPagination.pageSize,
            workGroupId: locationSearch.current.workGroupId
        }))
    }, [classficationPagination.pageIndex, classficationPagination.pageSize])
    // 从表格数据中剔重得出类型列表
    useEffect(() => {
        if (listLoading) {
            setTimeout(() => {
                setListLoading(false)
            }, 1000)
        }
        const groupByCategory = classification.reduce((group: any, product) => {
            const { classId } = product
            group[classId] = group[classId] || []
            group[classId].push(product)
            return group
        }, {})
        const _classArr: any[] = []
        Object.keys(groupByCategory).forEach(key => {
            _classArr.push(groupByCategory[key][0])
        })
        console.log('_classArr: ', _classArr)
        setClassArr([..._classArr])
    }, [classification])
    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            
            <Button type="primary" 
                onClick={handleAdd}
                className={authInfo && Reflect.has(authInfo, 'addClass') ? '' : 'hide'}
                style={{ margin: '0 100px 16px' }}
            >
                {t('add')}
            </Button>

            <List className="workground_ls"
                style={{ marginBottom: 0 }}
                itemLayout="horizontal"
                dataSource={classArr}
                loading={listLoading}
                renderItem={item => (
                    <List.Item
                        actions={[
                            <Text title={t('edit')}
                                className={authInfo && Reflect.has(authInfo, 'editClass') ? 'txt_blue hand' : 'hide'}
                                onClick={() => onEditClassification(item)} 
                            ><FormOutlined style={{ fontSize: 16 }} /></Text>, 
                            <Text title={t('delete')}
                                className={authInfo && Reflect.has(authInfo, 'delClass') ? 'txt_red hand' : 'hide'}
                                onClick={() => onDelClassification(item)} 
                            ><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                        ]}
                    >
                        <Skeleton avatar title={false} loading={listLoading} active>
                            <List.Item.Meta
                                title={item.classificationName}
                            />
                        </Skeleton>
                    </List.Item>
                )}
            />

            <Modal
                title={modalTitle}
                visible={modalVisible}
                onCancel={handleCancel}
                footer={null}
                destroyOnClose
            >
                <Form {...layout} form={form} name="control-ref" onFinish={onFinish}>
                    <Form.Item name="id" hidden><Input /></Form.Item>
                    <Form.Item name="version" hidden><Input /></Form.Item>
                    <Form.Item name="workGroupId" label={t('Work Group')}>
                        {selectGroupworkId
                            ? (<span>
                                <Input type='hidden' />
                                {workgroupList.find(workgroup => workgroup.id === selectGroupworkId)?.groupName}
                            </span>)
                            : (
                                <Select allowClear placeholder={t('Work Group Placeholder')}
                                    onChange={e => {
                                        if (e) {
                                            setSelectGroupworkId(e)
                                            dispatch(setClassificationPagination({
                                                pageIndex: 1
                                            }))
                                        }
                                    }}
                                >
                                    {
                                        workgroupList.map(item => {
                                            return <Option key={item.id} value={item.id}>{item.groupName}</Option>
                                        })
                                    }
                                </Select>
                            )
                        }
                    </Form.Item>
                    <Form.Item name="classificationName" label={t('Classification')} 
                        rules={[{ required: true, message: t('Classification Required') }]}
                    >
                        <NoSpaceInput placeholder={t('Classification Placeholder')} />
                    </Form.Item>
                    <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                        <Space size={20}>
                            <Button type="primary" htmlType="submit">
                                {t('submit')}
                            </Button>
                            <Button htmlType="button" onClick={onReset}>
                                {t('reset')}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>

            {classficationPagination.total !== 0 && (
                <Pagination style={{ margin: '0 100px 20px', textAlign: 'right' }}
                    defaultCurrent={classficationPagination.pageIndex}
                    current={classficationPagination.pageIndex}
                    total={classficationPagination.total}
                    pageSize={classficationPagination.pageSize}
                    onChange={(page: number) => {
                        dispatch(setClassificationPagination({
                            pageIndex: page
                        }))
                    }}
                />
            )}
        </Space>
    )
}

export default ClassificationEdit
